import { createStore } from "./store";

export type ToastTone = "up" | "down" | "info" | "error";
export type Toast = { id: number; tone: ToastTone; title: string; body?: string; at: number };

export const toasts = createStore<Toast[]>([]);

let next = 1;

export function toast(tone: ToastTone, title: string, body?: string): number {
  const id = next++;
  const item: Toast = body === undefined ? { id, tone, title, at: Date.now() } : { id, tone, title, body, at: Date.now() };
  toasts.set((all) => [item, ...all].slice(0, 5));
  return id;
}

export function dismiss(id: number) {
  toasts.set((all) => all.filter((item) => item.id !== id));
}
